export const getAttr = (el, name, { fallback = null, trim = true } = {}) => {
  if (!el || !el.hasAttribute(name)) return fallback;
  const v = el.getAttribute(name);
  if (v == null) return fallback;
  return trim ? v.trim() : v;
};

export const parseBool = (val, fallback = false) => {
  if (val == null) return fallback;
  const s = String(val).trim().toLowerCase();
  if (['true', '1', 'yes'].includes(s)) return true;
  if (['false', '0', 'no'].includes(s)) return false;
  return fallback;
};

export const parseIntSafe = (val, fallback = null) => {
  if (val == null || val === '') return fallback;
  const n = Number.parseInt(val, 10);
  return Number.isNaN(n) ? fallback : n;
};

export const addThemeStylesheet = (nameTheme = 'MR') => {
  const theme = String(nameTheme || 'MR')
    .trim()
    .toUpperCase();
  const id = `tracking-theme-${theme}`;
  if (document.getElementById(id)) return;

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `/Scripts/vue/tracking/css/style${theme}.css`;
  document.head.appendChild(link);
};

export const extractShipment = raw => {
  if (!raw) return '';
  const s = String(raw);
  return s.length === 26 ? s.slice(0, 10) : s;
};

export const normalizeBrand = (raw, forcedShort = false) => {
  if (!raw) return '';
  const v = String(raw).trim();
  return forcedShort ? v.slice(0, 2) : v;
};
